import { MembershipType, } from '../../../store/features/system/types';
import config from '../../../../app/global/env.config';
import { routerHelperFactory } from '../../../global/common/services/route-helper-factory';
import { API } from '../../../vendor/api';
export const getActiveRooms = async (userId, institutionId = null) => {
    return API.user.getAvailableRooms({
        userId,
        institutionId,
    });
};
export const addSubdomain = (url, subdomain) => {
    const subdomainDivider = routerHelperFactory.getSubdomainDivider();
    return [
        url.replace('//', `//${subdomain ? subdomain + subdomainDivider : ''}`),
        '/',
    ].join('');
};
export const getLandingUrl = (institution) => {
    const { baseUrl } = config;
    const { domain } = institution;
    return addSubdomain(baseUrl, domain);
};
export const getLandingPage = (institution) => {
    return {
        id: 'landing',
        cameraOff: false,
        doxyBotCheckIn: false,
        roomMemberships: [],
        isPersonal: false,
        usePasscode: false,
        institution: {
            domain: institution.domain,
        },
        url: getLandingUrl(institution),
        slug: '',
        name: '',
        passcode: '',
    };
};
export const institutionSort = (adminRooms, memberRooms, instDomain = '') => {
    const instSorted = [];
    for (const room of adminRooms) {
        if (room.institution?.domain === instDomain) {
            instSorted.unshift(room);
        }
        else {
            instSorted.push(room);
        }
    }
    return [...instSorted, ...memberRooms];
};
export const sortRooms = (rooms, user, instDomain = '') => {
    const hasAdminMembership = (room) => {
        return room.roomMemberships?.some((roomMembership) => roomMembership.role === MembershipType.admin &&
            roomMembership.userId === user.id);
    };
    const adminRooms = rooms.filter(function (room) {
        return hasAdminMembership(room);
    });
    const memberRooms = rooms.filter(function (room) {
        return !hasAdminMembership(room);
    });
    const sortedRooms = (instDomain
        ? institutionSort(adminRooms, memberRooms, instDomain)
        : [...adminRooms, ...memberRooms]).sort((room) => (room.isPersonal ? -1 : 1));
    const userPersonalRoom = sortedRooms.find((sortedRoom) => {
        return sortedRoom.roomMemberships.find((roomMembership) => roomMembership.role === MembershipType.admin &&
            roomMembership.userId === user.id);
    });
    // make current user personal room first in array
    if (!userPersonalRoom) {
        return sortedRooms;
    }
    return [
        userPersonalRoom,
        ...sortedRooms.filter((room) => room.id !== userPersonalRoom.id),
    ];
};
export const isLandingRoom = (room) => {
    return room.id === 'landing';
};
